import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
  , handleCallback
  , subKeySaga
  , fillDictionary
} from "shared-utility/store/utils/helpers";

// ACTIONS

export const QUOTES_HISTORY_GET_QUOTES = generateDefaultActions("QUOTES_HISTORY_GET_QUOTES");
export const quotesGetQuotes = payload => makePayload(QUOTES_HISTORY_GET_QUOTES.value, payload);
function* quotesGetQuotesSaga(payload) {
  const url = "/loans/getLoanLosingPRQuotes";
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(QUOTES_HISTORY_GET_QUOTES, url, "POST", payload);
}

const QUOTES_HISTORY_GET_LOAN = generateDefaultActions("QUOTES_HISTORY_GET_LOAN");
export const loanDetailGetLoan = payload => makePayload(QUOTES_HISTORY_GET_LOAN.value, payload);
function* loanDetailGetLoanSaga(payload) {
  const url = `/loans/getLoanDetails/${payload.loanId}`;
  yield requestSaga(QUOTES_HISTORY_GET_LOAN, url, "GET");
}

// REDUCER

const initialState = {
  quotes: {}
};

export function quoteHistoryReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case QUOTES_HISTORY_GET_QUOTES.success:
      return fillDictionary(state, payload, "quotes", subKey);
    case QUOTES_HISTORY_GET_LOAN.success:
      return defaultReturn(state, payload.data, "loan");
    default:
      return state;
  }
}

// SAGA

export function* quoteHistorySaga() {
  yield takeEvery(QUOTES_HISTORY_GET_QUOTES.value, quotesGetQuotesSaga);
  yield takeEvery(QUOTES_HISTORY_GET_LOAN.value, loanDetailGetLoanSaga);
}
